// removed by extract-text-webpack-plugin
module.exports = {"base":"Filter_base--FSIWa","caption":"Filter_caption--3Lm9n","item":"Filter_item--1I2fK"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Filter/Filter.css
// module id = 1760
// module chunks = 16